import { Component, Input, OnInit } from "@angular/core";
import { WebsocketService } from "../../../../websocket.service";
interface DataTableColumn {
	title: string;
	field: string;
	type?: string;
	default?: any;
}

@Component({
	selector: "app-datatable-column",
	templateUrl: "./column.component.html",
	styleUrls: ["./column.component.scss"],
})
export class ColumnComponent implements OnInit {
	@Input() data: any;
	@Input() column: any = {
		field: "",
		type: "",
		default: "",
	};

	dataField: any;

	constructor() {}

	ngOnInit(): void {
		this.dataField = this.data;

		if ("field" in this.column) {
			this.dataField = this.data[this.column.field];

			const test = /\.+/gm;
			if (test.test(this.column.field)) {
				const fieldArr = this.column.field.split(".");
				this.dataField = this.getDataField(fieldArr, this.data);
			}
		}
	}
	formatBw(bytes: any): string {
		const value = Number(bytes);
		return isNaN(value) ? "0 GB" : (value / 1024 ** 3).toFixed(2) + " GB";
	}
	formatDate(dateStr: string): string {
		if (!dateStr) return "Sin datos";

		const date = new Date(dateStr);
		if (isNaN(date.getTime())) return "Sin datos";

		const fecha = date.toLocaleDateString("es-MX"); // formato dd/mm/yyyy
		const hora = date.toLocaleTimeString("es-MX", {
			hour: "2-digit",
			minute: "2-digit",
			hour12: false,
		});

		return `${fecha} ${hora}`;
	}

	getConnectionStatus(dateStr: string): string {
		if (!dateStr) {
			return "gray";
		}

		const now = new Date();
		const last = new Date(dateStr);
		const diffHrs = (now.getTime() - last.getTime()) / (1000 * 60 * 60);

		if (diffHrs < 1) {
			return "green";
		}

		if (diffHrs < 12) {
			return "yellow";
		}

		if (diffHrs < 24) {
			return "red";
		}

		return "gray";
	}

	public getLiveConection(dateStr: string): string{
		// console.log(dateStr)
		return "hola"
	}

	public getConnectionTooltip(dateStr: string): string {
		// this.wsService.emit("join", this.data.channel);

		// console.log(this.data)
		if (!dateStr) {
			return "Sin conexión";
		}

		const date = new Date(dateStr);

		date.setHours(date.getHours() - 6);
		
		const fecha = date.toLocaleDateString("es-MX"); // ej. 06/08/2025
		const hora = date.toLocaleTimeString("es-MX", {
			hour: "2-digit",
			minute: "2-digit",
			hour12: false, // o true si prefieres formato 12 horas
		});



		return `Última conexión: ${fecha} ${hora}`;
	}

	getDataField(fields: Array<string>, data: any): any {
		let result = "";
		if (data !== null) {
			const field = fields.shift();
			result = data[field];

			if (fields.length > 0) {
				result = this.getDataField(fields, result);
			}
		}

		if (
			result === "" &&
			"default" in this.column &&
			this.column.default !== ""
		) {
			result = this.column.default;
		}

		return result;
	}

	public getDate(evidence): any {
		return new Date(parseInt(evidence.date, 10) * 1000);
	}
}
